import { Building2, Home, CheckSquare, Plane, Clock } from "lucide-react";
import { SHIFT, PRIORITY, HOLIDAY } from "@/lib/colors";

export const ShiftChip = ({ shift, name, compact, onClick }) => {
  const s = SHIFT[shift.location];
  const Icon = shift.location === "office" ? Building2 : Home;
  const pending = shift.roster_status && shift.roster_status !== "approved";
  return (
    <button
      type="button"
      onClick={onClick}
      data-testid={`shift-chip-${shift.id}`}
      className={`w-full text-left rounded-lg border px-2 py-1.5 text-[12px] leading-tight transition-transform duration-150 hover:-translate-y-0.5 hover:shadow-sm ${s.cls} ${pending ? "border-dashed" : ""}`}
    >
      <span className="flex items-center gap-1.5 font-bold">
        <Icon className="w-3.5 h-3.5 shrink-0" />
        <span className="truncate">{name || `${shift.start}–${shift.end}`}</span>
      </span>
      {!compact && (
        <span className="block mt-0.5 opacity-80 truncate">
          {name ? `${shift.start}–${shift.end} · ` : ""}{s.label}{pending ? ` · ${shift.roster_status}` : ""}
        </span>
      )}
    </button>
  );
};

export const TaskChip = ({ task, compact, onClick }) => {
  const p = PRIORITY[task.priority];
  const done = task.status === "done";
  return (
    <button
      type="button"
      onClick={onClick}
      data-testid={`task-chip-${task.id}`}
      className="w-full text-left rounded-lg border border-amber-200 bg-white border-l-[3px] border-l-amber-500 px-2 py-1.5 text-[12px] leading-tight transition-transform duration-150 hover:-translate-y-0.5 hover:shadow-sm"
    >
      <span className={`flex items-center gap-1.5 font-bold text-slate-800 ${done ? "line-through opacity-60" : ""}`}>
        <CheckSquare className="w-3.5 h-3.5 shrink-0 text-amber-600" />
        <span className="truncate">{task.title}</span>
        <span className={`ml-auto w-1.5 h-1.5 rounded-full shrink-0 ${p.dot}`} />
      </span>
      {!compact && (
        <span className="flex items-center gap-1 mt-0.5 text-slate-500 truncate">
          <Clock className="w-3 h-3 shrink-0" /> {task.due.slice(11, 16)} · by {task.assigned_by_name}
        </span>
      )}
    </button>
  );
};

export const HolidayChip = ({ holiday, showName = true, onClick }) => {
  const h = HOLIDAY[holiday.type];
  return (
    <button
      type="button"
      onClick={onClick}
      data-testid={`holiday-chip-${holiday.id}`}
      className={`holiday-stripes w-full text-left rounded-lg border px-2 py-1.5 text-[12px] leading-tight font-bold flex items-center gap-1.5 ${h.cls}`}
    >
      <Plane className="w-3.5 h-3.5 shrink-0" />
      <span className="truncate">{showName ? `${holiday.user_name.split(" ")[0]} off` : h.label}</span>
    </button>
  );
};

export const Legend = () => (
  <div className="flex flex-wrap items-center gap-x-4 gap-y-2 text-[12px] text-slate-600" data-testid="calendar-legend">
    <span className="flex items-center gap-1.5"><span className="w-3 h-3 rounded bg-teal-100 border border-teal-400" /> Office shift</span>
    <span className="flex items-center gap-1.5"><span className="w-3 h-3 rounded bg-indigo-100 border border-indigo-400" /> Remote shift</span>
    <span className="flex items-center gap-1.5"><span className="w-3 h-3 rounded bg-white border border-amber-300 border-l-[3px] border-l-amber-500" /> Task</span>
    <span className="flex items-center gap-1.5"><span className="w-3 h-3 rounded bg-rose-100 border border-rose-300 holiday-stripes" /> Leave</span>
    <span className="flex items-center gap-1.5"><span className="w-3 h-3 rounded border border-dashed border-slate-400" /> Not yet approved</span>
  </div>
);
